// src/components/Notification/NotificationSnackbar.tsx
import React from "react";
import styles from "./styles.module.scss";

const NotificationSnackbar = ({
  message,
  onClose,
  progress,
  icon,
  bg,
}: any) => {
  return (
    <div
      className={styles.customSnackbar}
      style={{ border: `2px solid ${bg}` }}
    >
      <div className={styles.iconCircle} style={{ background: bg }}>
        {icon}
      </div>
      <span className={styles.snackbarText}>{message}</span>
      <button
        className={styles.closeBtn}
        onClick={onClose}
        style={{ color: "#000" }}
      >
        ×
      </button>
      <div className={styles.progressBar}>
        <div
          className={styles.progress}
          style={{
            width: `${progress}%`,
            transition: "width 0.1s linear",
            background: bg,
          }}
        />
      </div>
    </div>
  );
};

export default NotificationSnackbar;
